import OSS from "ali-oss";
import { v4 as uuidv4 } from "uuid";
import config from "@/config";
import { isDev } from "@/libs/utils/";

export const OSSUpload = (
  ossCfgname,
  file,
  options = {
    filename: "",
    progress: null
  }
) => {
  return new Promise(resolve => {
    const uuid = uuidv4();
    const ossCfg = config.ossCfg[`${ossCfgname}${isDev() ? "Dev" : ""}`];

    const client = new OSS(ossCfg);
    // const { name } = file;
    const name = file["name"] || (options && options["filename"]) || "";
    const [filenameStr, suffix] = name.split(".");
    // 上传文件名
    const fileName = `${uuid}.${suffix}`;

    client
      .multipartUpload(fileName, file, {
        progress: pro =>
          options &&
          options["progress"] &&
          typeof options.progress === "function" &&
          options.progress(Math.floor(pro * 100))
      })
      .then(result => {
        const { res = {} } = result;
        const { status = -1 } = res || {};
        resolve(
          status === 200
            ? {
                uuid,
                name,
                formatName: fileName
              }
            : ""
        );
      });
  });
};
